export const DYNAMIC_COMMAND_PATTERNS = {
  click: [
    {
      pattern: /^element\/[^/]+\/click$/,
      label: "Click on Element"
    }
  ],
  element: [
    {
      pattern: /^element\/[^/]+\/name$/,
      label: "Get Element Tag Name"
    },
    {
      pattern: /^element\/[^/]+\/submit$/,
      label: "Submit Form"
    },
    {
      pattern: /^element\/[^/]+\/displayed$/,
      label: "Is Element Displayed"
    },
    {
      pattern: /^element\/[^/]+\/selected$/,
      label: "Is Element Selected"
    },
    {
      pattern: /^element\/[^/]+\/enabled$/,
      label: "Is Element Enabled"
    },
    {
      pattern: /^element\/[^/]+\/click$/,
      label: "Click on Element"
    },
    {
      pattern: /^element\/[^/]+\/value$/,
      label: "Send Keys to Element"
    },
    {
      pattern: /^element\/[^/]+\/clear$/,
      label: "Clear Element Text"
    },
    {
      pattern: /^element\/[^/]+\/rect$/,
      label: "Get Element Rect"
    },
    {
      pattern: /^element\/[^/]+\/shadow$/,
      label: "Get Element Shadow Root"
    },
    {
      pattern: /^element\/[^/]+\/computedrole$/,
      label: "Get Computed Role"
    },
    {
      pattern: /^element\/[^/]+\/computedlabel$/,
      label: "Get Computed Label"
    },
    {
      pattern: /^element\/[^/]+\/screenshot$/,
      label: "Take Element Screenshot"
    },
    {
      pattern: /^element\/[^/]+\/upload$/,
      label: "Upload File to Element"
    },
    {
      pattern: /^element\/[^/]+\/download$/,
      label: "Download File from Element"
    },
    {
      pattern: /^element\/[^/]+\/text$/,
      label: "Get Element Text"
    },
    {
      pattern: /^element\/[^/]+\/isDisplayed$/,
      label: "Check if Element is Displayed"
    },
    {
      pattern: /^element\/[^/]+\/isEnabled$/,
      label: "Check if Element is Enabled"
    },
    {
      pattern: /^element\/[^/]+\/isSelected$/,
      label: "Check if Element is Selected"
    },
    {
      pattern: /^element\/[^/]+\/drag$/,
      label: "Drag Element"
    },
    {
      pattern: /^element\/[^/]+\/tap$/,
      label: "Tap on Element"
    },
    {
      pattern: /^element\/[^/]+\/location$/,
      label: "Get Element Location"
    },
    {
      pattern: /^element\/[^/]+\/size$/,
      label: "Get Element Size"
    },
    {
      pattern: /^element\/[^/]+\/location_in_view$/,
      label: "Get Element Location in View"
    },
    {
      pattern: /^shadow\/[^/]+\/element$/,
      label: "Find Element From Shadow Root"
    },
    {
      pattern: /^element\/[^/]+\/attribute\/[^/]+$/,
      label: "Get Element Attribute"
    },
    {
      pattern: /^element\/[^/]+\/css\/[^/]+$/,
      label: "Get Element CSS Value"
    },
    {
      pattern: /^element\/[^/]+\/property\/[^/]+$/,
      label: "Get Element Property"
    }
  ],
  elements: [
    {
      pattern: /^shadow\/[^/]+\/elements$/,
      label: "Find Elements From Shadow Root"
    }
  ]
};

export const RerunTypeMap = {
  REPRODUCE: "reproduce",
  REPLAY: "replay"
};

export const DebuggerState = {
  RUNNING: "running",
  PAUSED: "paused",
  STOPPED: "stopped"
};

export const HistoryTypeMap = {
  HISTORY: "history",
  REPRODUCE: "reproduce",
  REPLAY: "replay"
};

export const AssetType = {
  SCREENSHOT: "screenshot",
  VIDEO: "video"
};

export const UtcOffsets = [
  "UTC+00:00",
  "UTC+01:00",
  "UTC+02:00",
  "UTC+03:00",
  "UTC+03:30",
  "UTC+04:00",
  "UTC+04:30",
  "UTC+05:00",
  "UTC+05:30",
  "UTC+05:45",
  "UTC+06:00",
  "UTC+06:30",
  "UTC+07:00",
  "UTC+08:00",
  "UTC+09:00",
  "UTC+09:30",
  "UTC+10:00",
  "UTC+11:00",
  "UTC+12:00",
  "UTC+13:00",
  "UTC-01:00",
  "UTC-02:00",
  "UTC-03:00",
  "UTC-03:30",
  "UTC-04:00",
  "UTC-05:00",
  "UTC-06:00",
  "UTC-07:00",
  "UTC-08:00",
  "UTC-09:00",
  "UTC-10:00",
  "UTC-11:00",
  "UTC-12:00"
];

export const otherStatus = [
  {
    name: "Completed",
    value: "completed"
  },
  {
    name: "Skipped",
    value: "skipped"
  },
  {
    name: "Unknown",
    value: "unknown"
  },
  {
    name: "Ignored",
    value: "ignored"
  },
  {
    name: "Idle Timeout",
    value: "idle_timeout"
  },
  {
    name: "Queue Timeout",
    value: "queue_timeout"
  },
  {
    name: "Stopped",
    value: "stopped"
  },
  {
    name: "Cancelled",
    value: "cancelled"
  },

  {
    name: "Error",
    value: "error"
  },
  {
    name: "Lambda Error",
    value: "lambda error"
  }
];

export const testStatus = [
  {
    name: "Passed",
    value: "passed"
  },
  {
    name: "Running",
    value: "running"
  },
  {
    name: "Failed",
    value: "failed"
  },
  {
    name: "Queued",
    value: "queued"
  },
  ...otherStatus
];
